import { Component, forwardRef, ViewChild } from "@angular/core";
import { Router } from "@angular/router";

import { Station } from "../../core";
import { AudioPlayerComponent, IMediaStream } from "../audio-player";

declare var dataLayer;

@Component({
  selector: "app-player-header",
  templateUrl: "./player-header.component.html",
  styleUrls: ["./player-header.component.scss"],
})
export class PlayerHeaderComponent {
  private SKIP_FIVE_SECONDS = 5;

  @ViewChild(forwardRef(() => AudioPlayerComponent), { static: true })
  private audioPlayer: AudioPlayerComponent;

  stationLogo = null;
  private placeholder = "https://via.placeholder.com/220x220?text=N/A";

  stationDetails: Station = null;
  rawTranscription: String = null;

  constructor(private router: Router) {}

  downloadAudio() {
    this.router.navigate(["downloads"], {
      queryParams: {
        stationId: this.stationDetails.id,
        entStationId: this.stationDetails.enterpriseStationId,
        segmentStartTime: this.audioPlayer.api.currentTime,
        currentTime: this.audioPlayer.api.currentTime,
      },
    });
    try {
      dataLayer.push({
        event: "click-transcription-audio-download",
        operation: "transcription-download-audio",
      });
    } catch (e) {
      console.error("downloadAudio", e);
    }
  }

  rowSelected(
    station: Station,
    playlistURL: string,
    autoPlay: boolean = false,
    rawTranscription: String = null,
    audioPositionSeconds: Number = null,
    playFromStart: Boolean = false,
  ) {
    this.stationDetails = station;
    this.rawTranscription = rawTranscription;
    if (station) {
      this.stationLogo = station.stationLogoUrl;
    } else {
      this.stationLogo = this.placeholder;
    }
    if (playlistURL) {
      const mediaStream: IMediaStream = {
        type: "hls",
        source: playlistURL,
        label: "Label",
      };

      const token = localStorage.getItem("msal.idtoken");
      if (audioPositionSeconds && !playFromStart) {
        const skipTo = audioPositionSeconds.valueOf();
        const skipToFiveSeconds =
          skipTo - this.SKIP_FIVE_SECONDS > 0
            ? skipTo - this.SKIP_FIVE_SECONDS
            : 0;
        this.audioPlayer.playStream(
          mediaStream,
          skipToFiveSeconds,
          autoPlay,
          token,
        );
      } else {
        // Resetting the player original pos
        this.audioPlayer.playStream(mediaStream, 0, autoPlay, token);
      }
    }
  }

  isPlaying(stationId: String = null): boolean {
    let playing: boolean = this.audioPlayer && this.audioPlayer.isPlaying();

    if (stationId && this.stationDetails && this.stationDetails.id) {
      playing = playing && stationId === this.stationDetails.id;
    }

    return playing;
  }

  play() {
    if (this.audioPlayer) {
      this.audioPlayer.play();
      try {
        dataLayer.push({
          event: "click-transcription-audio-play",
          operation: "transcription-play-audio",
        });
      } catch (e) {
        console.error("play", e);
      }
    }
  }

  pause() {
    if (this.audioPlayer) {
      this.audioPlayer.pause();
    }
  }

  stop() {
    if (this.audioPlayer) {
      this.audioPlayer.stop();
    }
  }

  setPlaceholderImage() {
    this.stationLogo = "assets/images/no-image-placeholder.jpg";
  }
}
